import NarrationText from './NarrationText'
import TaskSection from './TaskSection'
import ThoughtStep from './thoughtchain/ThoughtStep'
import { thoughtActivityCopy } from '@/features/chat/phase1/thoughtActivityKinds'

export default function ThoughtTimelineExtraRow({ item, streaming }) {
  if (item.kind === 'plan') {
    const copy = thoughtActivityCopy('plan')
    return (
      <TaskSection
        title={copy.title}
        caption={copy.explanation}
        tasks={item.tasks}
        streaming={streaming}
        checklist
      />
    )
  }
  return (
    <ThoughtStep
      category={item.category ?? 'thinking'}
      title={item.title}
      streaming={streaming}
      running={item.running}
    >
      {item.body ? <NarrationText text={item.body} /> : null}
    </ThoughtStep>
  )
}
